package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccab.CCABServer
import com.neurobs.ccabserver.administrator.contexts.{GuiContext, LoggerContext, MenuContext, MenuState, ResourceURLContext, ServerContext, TestStationContext, TestStationState, UserContext, UserState}
import com.neurobs.js.view.Gui
import com.neurobs.js.ccab.UserManager
import com.neurobs.util.Logger
import slinky.core.FunctionalComponent
import slinky.core.annotations.react

@react object Main {
	case class Props
	(
		resources: Map[ResourceURLContext.Resource.Value, String],
		server: CCABServer,
		gui: Gui,
		logger: Logger,
		userManager: UserManager,
	)

	val component = FunctionalComponent[Props] { props =>
		ResourceURLContext.provider(new ResourceURLContext(props.resources))(
			ServerContext.provider(value = props.server)(
				LoggerContext.provider(value = props.logger)(
					GuiContext.provider(value = props.gui)(
						UserContext.provider(UserState(user = props.userManager.getUser, manager = props.userManager, server = props.server))(
							MenuContext.provider(MenuState(selection = Some(MenuState.MenuItemType.TestStations)))(
								TestStationContext.provider(TestStationState())(
									Application.View()
								)
							)
						)
					)
				)
			)
		)
	}
}
